import { DextUrlInputWUT } from '@wix/form-fields/viewer-wut';

export default DextUrlInputWUT;
